import { ClipPath, Defs, G, Path, Rect, Svg } from 'react-native-svg'

// eslint-disable-next-line no-relative-import-paths/no-relative-import-paths
import { createIcon } from '../factories/createIcon'

export const [SmartWallet, AnimatedSmartWallet] = createIcon({
  name: 'SmartWallet',
  getIcon: (props) => (
    <Svg viewBox="0 0 25 24" fill="none" {...props}>
      <G clipPath="url(#clip0_2048_10941)">
        <Path
          d="M24.5 8.51603C22.1372 8.51603 20.086 6.40122 20.086 4.03931C20.086 6.41843 17.75 8.38928 15.5 8.51603C17.8629 8.51603 19.8845 10.7632 20.0028 13.0393C20.1211 10.7632 22.1372 8.51603 24.5 8.51603Z"
          fill={'currentColor' ?? '#FF37C7'}
        />
        <Path
          d="M17.7499 5.83937C17.8295 5.83937 17.9081 5.8435 17.9856 5.85156C17.4522 6.41541 16.7771 6.90198 15.9039 7.33937H5.74999C5.33578 7.33937 4.99999 7.67515 4.99999 8.08936V8.96768C5.23488 8.88458 5.48763 8.83936 5.75085 8.83936H14.2811C15.2601 9.1888 16.1405 9.70031 16.9007 10.3394H5.75085C5.33608 10.3394 4.99999 10.6757 4.99999 11.0894V12.04C5.22062 11.9124 5.47677 11.8393 5.74998 11.8393H8.68582C9.12425 11.8393 9.47428 12.2855 9.64517 12.747C9.86156 13.3313 10.4675 13.9822 11.75 13.9822C13.0917 13.9822 13.5828 13.2697 13.8233 12.6664C13.9951 12.2356 14.3357 11.8393 14.7499 11.8393H17.7499C17.9861 11.8393 18.2095 11.8939 18.4083 11.9911C19.3184 13.2965 19.8756 14.8639 19.9902 16.5498C19.8841 17.6938 18.9216 18.5893 17.7499 18.5893H5.74999C4.50736 18.5893 3.5 17.582 3.5 16.3393V8.08936C3.5 6.84673 4.50736 5.83937 5.74999 5.83937H17.7499Z"
          fill={'currentColor' ?? '#FF37C7'}
        />
      </G>
      <Defs>
        <ClipPath id="clip0_2048_10941">
          <Rect width="24" height="24" fill="white" transform="translate(0.5)" />
        </ClipPath>
      </Defs>
    </Svg>
  ),
  defaultFill: '#FF37C7',
})
